import axios from "axios";
import { API } from "./api";
import { getAdminToken, clearAdminToken } from "./adminAuth";

const adminClient = axios.create({ baseURL: API });

adminClient.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminClient.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) clearAdminToken();
    return Promise.reject(error);
  }
);

export const adminLogin = (password) =>
  adminClient.post("/admin/login", { password }).then((r) => r.data);

export const createProgram = (payload) => adminClient.post("/programs", payload).then((r) => r.data);
export const updateProgram = (id, payload) =>
  adminClient.put(`/programs/${id}`, payload).then((r) => r.data);
export const deleteProgram = (id) => adminClient.delete(`/programs/${id}`).then((r) => r.data);

export const createVideo = (payload) => adminClient.post("/videos", payload).then((r) => r.data);
export const updateVideo = (id, payload) =>
  adminClient.put(`/videos/${id}`, payload).then((r) => r.data);
export const deleteVideo = (id) => adminClient.delete(`/videos/${id}`).then((r) => r.data);

export const createLiveStream = (payload) =>
  adminClient.post("/live-streams", payload).then((r) => r.data);
export const updateLiveStream = (id, payload) =>
  adminClient.put(`/live-streams/${id}`, payload).then((r) => r.data);
export const deleteLiveStream = (id) =>
  adminClient.delete(`/live-streams/${id}`).then((r) => r.data);

export const uploadImage = (file) => {
  const form = new FormData();
  form.append("file", file);
  return adminClient.post("/admin/upload/image", form).then((r) => r.data);
};

export const uploadVideoFile = (file) => {
  const form = new FormData();
  form.append("file", file);
  return adminClient.post("/admin/upload/video", form).then((r) => r.data);
};
